import { Divider, Grid, Typography } from '@mui/material';
import { isEmpty, orderBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import NoteDoRPreview from './noteDoRPreview';

const ClinicalNoteAttachments = ({ note, patient }) => {
    const { t } = useTranslation();

    const renderAttachments = () => {
        return (
            <Grid container gap={10}>
                {orderBy(note.attachments, ['type', 'createdDate'], ['asc', 'acs']).map((att, index) => {
                    const getButtonType = () => {
                        switch (att?.type) {
                            case 'DynamicFormDoR':
                                return <NoteDoRPreview attachment={att} disabled={note?.canceled} patient={patient} />;

                            default:
                                console.warn('Unknown attachment type', att?.typ);
                                return null;
                        }
                    };

                    return (
                        <Grid item xs={12} key={index + '_' + att?.createdDate}>
                            {getButtonType()}
                        </Grid>
                    );
                })}
            </Grid>
        );
    };

    if (!patient || isEmpty(note?.attachments)) return null;

    return (
        <>
            <Divider style={{ margin: '10px 0' }} />
            <Typography variant="subtitle2" gutterBottom>
                {t('Attachments')}:
            </Typography>

            {renderAttachments()}
        </>
    );
};

export default ClinicalNoteAttachments;
